import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { SquaredTickIcon } from "../../ui/icons/SquaredTickIcon"
import { ButtonComponent } from "../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static"
import { formatterDate, normativa, optionsFormatter, ServiceTypeNormoptions, yearOptions } from "../../utils"
import { BillingWorksheetDTO } from "./dataService/dto"
import { GetAllBillingWorksheet, setBWCreationNorm, setBWCreationYear, setBWIdToUpdate, setOnEdit } from "./slice"

export function SchedaCalcoloList() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const serviceAndBillingState = useAppSelector(state => state.billingAndServiceType)
    const worksheets = serviceAndBillingState.getAllBillingWorksheetResponse?.data ?? []
    const [selectedNorm, setSelectedNorm] = useState<string | null>(null)
    const [selectedYear, setSelectedYear] = useState<string | null>(null)

    useEffect(() => {
        dispatch(GetAllBillingWorksheet(serviceAndBillingState.getAllBillingWorksheetFilters))
    }, [])

    const handleOnEdit = (sc: BillingWorksheetDTO) => {
        dispatch(setBWCreationNorm(sc.norm))
        dispatch(setBWCreationYear(sc.year))
        dispatch(setBWIdToUpdate(sc.id))
        dispatch(setOnEdit(true))
        navigate('/schedaCalcoloEdit')
    }

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-4">
                <div className="flex flex-row gap-2 items-center">
                    <MadfarmStaticSelect
                        placeholder="Specifica normativa..."
                        noOptionsMessage="Nessuna normativa disponibile"
                        options={normativa}
                        value={selectedNorm}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            setSelectedNorm(newValue as string | null)
                        }}
                    />
                    <MadfarmStaticSelect
                        placeholder="Specifica anno..."
                        noOptionsMessage="Nessun anno disponibile"
                        options={yearOptions}
                        value={selectedYear}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            setSelectedYear(newValue as string | null)
                        }}
                    />
                    <div className="flex flex-row gap-2 items-center w-[20%]">
                        <ButtonComponent
                            size="lg"
                            iconPosition="off"
                            variant="outline"
                            label="Pulisci"
                            color="gray"
                            onClick={() => { }}
                        />
                        <ButtonComponent
                            variant="solid"
                            color="blue"
                            size="lg"
                            iconPosition="off"
                            label="Cerca"
                            onClick={() => { }}
                        />
                    </div>
                </div>
            </div>
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl"></th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Anno</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Data Emissione</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Normativa</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {worksheets.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                    Nessuna scheda di calcolo trovata
                                </td>
                            </tr>
                        ) : (
                            worksheets.map((sc, index) => (
                                <tr
                                    key={sc.id ?? index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-600"></td>
                                    <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                        {sc.year}
                                    </td>
                                    <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap text-xs">
                                        {formatterDate(sc.createdAt!)}
                                    </td>
                                    <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                        {optionsFormatter(sc.norm, ServiceTypeNormoptions)}
                                    </td>
                                    <td className="px-3 py-2 w-[60px]">
                                        <div className="flex items-center justify-center gap-2">
                                            <button
                                                className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                onClick={() => handleOnEdit(sc)}
                                            >
                                                <SquaredTickIcon />
                                                <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                    Seleziona Scheda
                                                </span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}